/**
 * Admin Shared Utilities
 * Common formatting functions and components used across admin pages
 */

// ==============================================
// Phone Number Formatting
// ==============================================

/**
 * Format phone number as (XXX) XXX-XXXX
 * @param {string} value - Raw or partially formatted phone input
 * @returns {string} Formatted phone number
 */
export const formatPhoneNumber = (value) => {
  if (!value) return '';
  const digits = value.replace(/\D/g, '');
  const limited = digits.slice(0, 10);
  if (limited.length === 0) return '';
  if (limited.length <= 3) return `(${limited}`;
  if (limited.length <= 6) return `(${limited.slice(0, 3)}) ${limited.slice(3)}`;
  return `(${limited.slice(0, 3)}) ${limited.slice(3, 6)}-${limited.slice(6)}`;
};

/**
 * Strip phone formatting for API storage
 * @param {string} value - Formatted phone number
 * @returns {string} Digits only
 */
export const stripPhoneFormatting = (value) => {
  if (!value) return '';
  return value.replace(/\D/g, '');
};
